function scrollIntoView(element, parent, position) {
  const offsetTop = element.getRootNode() !== parent.getRootNode() ? flatTreeOffsetTop(element) : element.offsetTop;
  switch (position) {
    case "start":
      parent.scrollTop = offsetTop;
      break;
    case "nearest":
      if (offsetTop < parent.scrollTop) {
        parent.scrollTop = offsetTop;
      }
      if (offsetTop + element.offsetHeight > parent.scrollTop + parent.offsetHeight) {
        parent.scrollTop = offsetTop + element.offsetHeight - parent.offsetHeight;
      }
      break;
  }
}
function flatTreeOffsetTop(element) {
  const offsetParent = element.offsetParent;
  let value = element.offsetTop;
  let nextOffsetParent = flatTreeOffsetParent(element);
  while (nextOffsetParent !== offsetParent) {
    value -= nextOffsetParent.offsetTop;
    nextOffsetParent = flatTreeOffsetParent(nextOffsetParent);
  }
  return value;
}
function flatTreeParent(element) {
  if (element.assignedSlot) {
    return element.assignedSlot;
  }
  if (element.parentNode instanceof ShadowRoot) {
    return element.parentNode.host;
  }
  return element.parentNode;
}
function flatTreeOffsetParent(element) {
  for (let ancestor = flatTreeParent(element); ancestor; ancestor = flatTreeParent(ancestor)) {
    if (!(ancestor instanceof Element)) continue;
    const style = getComputedStyle(ancestor);
    if (style.display === "contents") continue;
    if (style.position !== "static" || style.filter !== "none") {
      return ancestor;
    }
    if (ancestor.tagName === "BODY") return ancestor;
  }
  return null;
}

export { scrollIntoView as s };
